import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { Fragment, useState } from 'react';
import classNames from 'classnames/bind';
import { Card, Link, Text } from '@beef/ui-kit';
import { DIMENSION_GROUPS, useGetDimensionGroup } from "../../hooks/useGetDimensionGroup";
import { Description } from "./components/Description";
import { Icon } from "./components/Icon";
import Arrow from "./assets/arrow.svg";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var getWrapperType = function getWrapperType(wrapperLink) {
  if (wrapperLink !== null && wrapperLink !== void 0 && wrapperLink.href) {
    return 'a';
  }
  if (wrapperLink !== null && wrapperLink !== void 0 && wrapperLink.onClick) {
    return 'button';
  }
  return undefined;
};
var InfoCard = function InfoCard(_ref) {
  var title = _ref.title,
    wrapperLink = _ref.wrapperLink,
    text = _ref.text,
    step = _ref.step,
    button = _ref.button,
    icon = _ref.icon,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    backgroundColor = _ref.backgroundColor,
    onClick = _ref.onClick,
    classes = _ref.classes,
    isMobileView = _ref.isMobileView,
    onArrowClick = _ref.onArrowClick;
  var dimension = useGetDimensionGroup();
  var isMobile = dimension === DIMENSION_GROUPS.mobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var isMobileViewType = isMobileView && isMobile;
  var handleClick = function handleClick() {
    setIsOpen(!isOpen);
    onArrowClick === null || onArrowClick === void 0 ? void 0 : onArrowClick();
  };
  var wrapperType = getWrapperType(wrapperLink) || '';
  var Tag = wrapperType || Fragment;
  var className = cn(_defineProperty({}, "wrapper__".concat(wrapperType), !!wrapperType));
  var tagProps = _objectSpread(_objectSpread({}, wrapperLink), wrapperType ? {
    className: className
  } : {});
  return /*#__PURE__*/React.createElement(Tag, _extends({}, tagProps, {
    "data-t-id": "components-InfoCard"
  }), /*#__PURE__*/React.createElement(Card, {
    bordered: bordered,
    className: cn('wrapper', {
      'wrapper--bg': !backgroundColor && !bordered
    }, classes === null || classes === void 0 ? void 0 : classes.common),
    withHover: !!wrapperType && bordered,
    "data-t-id": "components-InfoCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn({
      details: backgroundColor || bordered
    }, isMobile && 'mobile'),
    style: {
      backgroundColor: backgroundColor
    },
    "data-t-id": "components-InfoCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('grow-content', isMobileViewType && 'mobile'),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(isMobileViewType && 'header-mobile')
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    isMobileView: isMobileView,
    step: step
  }), title && /*#__PURE__*/React.createElement(Text, {
    className: cn(isMobileViewType && 'mobile-header-text', classes === null || classes === void 0 ? void 0 : classes.title),
    size: isMobileViewType ? 'size5-m' : 'size4-m'
  }, title), !isMobileViewType && /*#__PURE__*/React.createElement(Description, {
    className: classes === null || classes === void 0 ? void 0 : classes.text
  }, text)), isMobileViewType && /*#__PURE__*/React.createElement(Arrow, {
    className: cn('arrow', isOpen && 'arrow-rotated')
  })), isMobileViewType && isOpen && /*#__PURE__*/React.createElement(Description, {
    className: classes === null || classes === void 0 ? void 0 : classes.text
  }, text), (button === null || button === void 0 ? void 0 : button.link) && (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/React.createElement("div", {
    className: cn('details__button')
  }, /*#__PURE__*/React.createElement(Link, {
    buttonSize: button.size || 'l',
    buttonVariant: button.variant || 'secondary',
    href: button.link,
    onClick: onClick,
    size: "size5-m",
    variant: "button"
  }, button.text)))));
};
export { InfoCard };